import React from 'react';

/**
 * Full-screen lightbox for enlarged product imagery on the Quote
 * Calculator. Click the backdrop OR the close (×) button OR the image
 * itself to dismiss. The parent owns scroll-lock side effects (so this
 * stays a pure render component).
 *
 * Extracted from QuoteCalculator.jsx (was inline at the bottom of the
 * tree) to keep the page file focused on flow + state orchestration.
 */
export const EnlargedImageModal = ({ open, src, onClose }) => {
  if (!open) return null;
  return (
    <div
      data-testid="quote-enlarged-image-modal"
      className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-7xl max-h-full">
        <button
          type="button"
          onClick={onClose}
          data-testid="quote-enlarged-image-close-btn"
          className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
          aria-label="Close"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <img
          src={src}
          alt="Enlarged product view"
          className="max-w-full max-h-[90vh] object-contain cursor-pointer"
          onClick={onClose}
        />

        <p className="text-center text-white text-sm mt-4 opacity-75">
          Click anywhere to close
        </p>
      </div>
    </div>
  );
};

export default EnlargedImageModal;
